module.exports = __webpack_public_path__ + "static/media/bImage.8ce7a168.png";